import { type Canvases } from '@air/api';
import { SortDirection } from '@air/api/types';

type CreateCanvasResponse = Awaited<ReturnType<typeof Canvases.create>>;
type ListCanvasesResponse = Awaited<ReturnType<typeof Canvases.list>>;
type GetCanvasResponse = Awaited<ReturnType<typeof Canvases.get>>;

export type Canvas = Extract<CreateCanvasResponse, { id: string }>;
export type CanvasListItem = Extract<ListCanvasesResponse, { data: unknown }>['data'][number];
export type CanvasListResponse = Extract<ListCanvasesResponse, { data: unknown }>;
export type CanvasDetail = Extract<GetCanvasResponse, { id: string }>;

export type CanvasRecentNode = NonNullable<CanvasListItem['recentNodes']>[number];

/** Derives the create params type from the actual API endpoint signature */
export type CreateCanvasParams = Omit<NonNullable<Parameters<typeof Canvases.create>[0]>, 'workspaceId'> & {
  workspaceId?: string;
};

export type CanvasesView = 'all' | 'recent' | 'mine';

export const CANVASES_SORT_FIELDS = ['title', 'createdAt', 'updatedAt'] as const;
export type CanvasesSortField = (typeof CANVASES_SORT_FIELDS)[number];
export type CanvasesOrderBy = { field: CanvasesSortField; direction: SortDirection };

export const isCanvasesSortField = (value: string): value is CanvasesSortField =>
  CANVASES_SORT_FIELDS.some((field) => field === value);

export const DEFAULT_CANVASES_ORDER_BY: CanvasesOrderBy = { field: 'updatedAt', direction: SortDirection.desc };
